/* Signature layer — soft fade-up as sections enter the viewport.
   - respects prefers-reduced-motion
   - skips the enter / splash overlay (like edition-smooth.js)
   - no-ops gracefully without IntersectionObserver */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.querySelector('.wrapper.enter--v2')) return;
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px 12% 0px', threshold: 0.01 }
  );

  function collect() {
    var main = document.getElementById('MainContent');
    if (!main) return [];
    var targets = [];

    /* Reveal *inner* content only. Putting an opacity transition on a
       `.shopify-section` wrapper briefly detaches it from the theme's fixed
       background section -> white flash. Inner blocks are safe. */

    // homepage / content sections: their first real content block
    var sections = main.querySelectorAll(':scope > .shopify-section.section, :scope > .shopify-section-group-content > .shopify-section.section');
    sections.forEach(function (sec, i) {
      if (i === 0) return;
      if (sec.querySelector('.product__info-container, .product__column-sticky')) return;
      var inner = sec.querySelector('.page-width, .isolate, .banner, .collage, .multicolumn, .newsletter, .rich-text__wrapper');
      if (inner) targets.push(inner);
    });

    // product page: related products (already an isolated stacking context)
    document.querySelectorAll('.related-products').forEach(function (el) {
      if (targets.indexOf(el) === -1) targets.push(el);
    });

    return targets;
  }

  function init() {
    collect().forEach(function (el) {
      if (el.dataset.sigReveal) return;
      el.dataset.sigReveal = '1';
      el.classList.add('sig-reveal');
      // already in view on load -> show immediately, don't animate in
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
        el.classList.add('is-in');
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
